import { TextField, TextFieldProps } from '@mui/material';
import { CharCounter } from '@prismamedia/one-components';
import clsx from 'clsx';
import { FC } from 'react';
import { useStyles } from './styles';

export const TextFieldWordCount: FC<TextFieldProps> = ({
  value,
  className,
  ...props
}) => {
  const classes = useStyles();

  return (
    <div className={clsx(className, classes.wrapper)}>
      <TextField value={value || ''} {...props} />
      <CharCounter content={value as string} />
    </div>
  );
};
